import React from "react";
import Grid from "@material-ui/core/Grid";
import arrowUp from "../assets/arrow-up.png";
import arrowDown from "../assets/arrow-down.png";
import "../styles/selectProgram.css";
import Clock from "../assets/clock-icon.png";
import action from "../assets/action.png";
import action2 from "../assets/action2.png";
import { useHistory } from "react-router-dom";
import ProductTemp from "./ProductTemp";
import ProductTime from "./ProductTime";
import GrillTemp from "./GrillTemp";
import back from "../assets/back.png";

function ManualMode() {
  let history = useHistory();

  const [mode, setMode] = React.useState("");

  const showMode = () => {
    if (mode === "ProductTime") {
      return <ProductTime />;
    }

    if (mode === "ProductTemp") {
      return <ProductTemp />;
    }

    if (mode === "GrillTemp") {
      return <GrillTemp />;
    }

    return (
      <Grid
        item
        xs={12}
        sm={4}
        md={12}
        style={{
          border: "2px solid #737374",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#fff",
            fontStyle: "italic",
           display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: 200,
          }}
        >
          Please select your options
        </h1>
      </Grid>
      
    );
  };

  return (
    <Grid
      container
      style={{
        border: "2px solid #737374",
        height: "100%",
      }}
    >
      <Grid
        onClick={() => {
          history.goBack();
        }}
        item
        xs={12}
        sm={4}
        md={2}
        className="btn"
        style={{
          border: "2px solid #737374",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 25,
        }}
      >
          <img width="80px" src={back} alt="" />
        <h3 style={{ marginLeft: 40 }}>Click Dial</h3>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={8}
        style={{
          border: "2px solid #737374",
        }}
      >
        <p className="title">Manual Mode</p>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        md={2}
        style={{
          border: "2px solid #737374",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "white",
          fontSize: 25,
        }}
      >
        <img
          onClick={() => setMode("ProductTemp")}
          className="btn"
          width="60px"
          style={{  borderRadius: 20, padding: 10 }}
          src={action}
          alt=""
        />
        <img
          onClick={() => setMode("ProductTime")}
          className="btn"
          width="60px"
          style={{  borderRadius: 20, padding: 10 }}
          src={Clock}
          alt=""
        />
        <img
          onClick={() => setMode("GrillTemp")}
          className="btn"
          width="60px"
          style={{  borderRadius: 20, padding: 10 }}
          src={action2}
          alt=""
        />
      </Grid>

     
      {showMode()}
    </Grid>
  );
}

export default ManualMode;
